import React from 'react';
import dynamic from 'next/dynamic';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { InstoreEnrollmentStatus } from 'src/state/instore-enrollment';
import { Login } from '../login';
import { useInstoreEnrollmentPage } from './use-instore-enrollment-page';
import { ConnectBank } from '../connect-bank';
import { PayByBankEnrollmentPage } from '../pay-by-bank-enrollment-page';
import { Success } from '../success';
import { Loyalty } from '../loyalty';
import { MedIntake } from '../med-intake/med-intake';
import { MedSuccess } from '../med-intake/med-success';

// Define the props type for the dynamic component based on the actual component
const InstoreEnrollmentLayout = dynamic<{ children: React.ReactNode }>(
  () => import('../instore-enrollment-layout').then((mod) => mod.InstoreEnrollmentLayout),
  { loading: () => <div>Loading...</div> }
);

export function InstoreEnrollmentPage(): JSX.Element {
  const { currentStatus } = useInstoreEnrollmentPage();
  const flags = useFlags();
  const isMedIntakeEnabled = flags['fintech.retail-payments.good-canna-integration-enabled.rollout'] ?? false;

  return (
    <InstoreEnrollmentLayout>
      <>
        {currentStatus === InstoreEnrollmentStatus.ecommLogin && <Login />}
        {currentStatus === InstoreEnrollmentStatus.medIntake && <MedIntake />}
        {currentStatus === InstoreEnrollmentStatus.loyaltyEnrollment && <Loyalty />}
        {currentStatus === InstoreEnrollmentStatus.payByBankEnrollment && <PayByBankEnrollmentPage />}
        {currentStatus === InstoreEnrollmentStatus.connectBankAccount && <ConnectBank />}
        {currentStatus === InstoreEnrollmentStatus.finishedEnrollment &&
          (isMedIntakeEnabled ? <MedSuccess /> : <Success />)}
      </>
    </InstoreEnrollmentLayout>
  );
}
